var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7556 16L9.15556 10.4C8.71111 10.7556 8.2 11.037 7.62222 11.2444C7.04444 11.4519 6.42963 11.5556 5.77778 11.5556C4.16296 11.5556 2.79644 10.9961 1.67822 9.87733C0.56 8.75852 0.000592593 7.392 0 5.77778C0 4.16296 0.559407 2.79644 1.67822 1.67822C2.79704 0.56 4.16356 0.000592593 5.77778 0C7.39259 0 8.75941 0.559407 9.87822 1.67822C10.997 2.79704 11.5561 4.16356 11.5556 5.77778C11.5556 6.42963 11.4519 7.04444 11.2444 7.62222C11.037 8.2 10.7556 8.71111 10.4 9.15556L16 14.7556L14.7556 16ZM5.77778 9.77778C6.88889 9.77778 7.83348 9.38904 8.61156 8.61156C9.38963 7.83407 9.77837 6.88948 9.77778 5.77778C9.77778 4.66667 9.38904 3.72237 8.61156 2.94489C7.83407 2.16741 6.88948 1.77837 5.77778 1.77778C4.66667 1.77778 3.72237 2.16682 2.94489 2.94489C2.16741 3.72296 1.77837 4.66726 1.77778 5.77778C1.77778 6.88889 2.16682 7.83348 2.94489 8.61156C3.72296 9.38963 4.66726 9.77837 5.77778 9.77778Z",
    fill: "#FFF2E9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.da19e1f452ef28e9ba56876a057ae3a2.svg";
export { ForwardRef as ReactComponent };